import { observer } from 'mobx-react';
import { ParticipantResource } from '../../../../../ParticipantsStore/Types';
import GroupParticipantsStore from '../../GroupParticipantsStore/Store';
import { GroupParticipantsResource } from '../../GroupParticipantsStore/Types';
import Body from './Body';
import Head from '../Head';

interface Props {
  participants: ParticipantResource[];
  groupParticipantsStore: GroupParticipantsStore;
  groupParticipantsResource: GroupParticipantsResource;
}

function ParticipantsTable({
  participants,
  groupParticipantsStore,
  groupParticipantsResource,
}: Props) {
  return (
    <table className="min-w-full divide-y divide-gray-300">
      <Head
        sorting={groupParticipantsStore.sorting}
        searchParameters={groupParticipantsStore.searchParameters}
      />
      <Body
        participants={participants}
        groupParticipantsResource={groupParticipantsResource}
        groupParticipantsStore={groupParticipantsStore}
      />
    </table>
  );
}

export default observer(ParticipantsTable);
